import { useState } from 'react'
import NavbarItem from './NavbarItem'
import NavbarMenu from './NavbarMenu'
import NavbarMenuItem from './NavbarMenuItem'
import Section from './Section'

interface HeaderProps {
  className?: string
}

export default function Navbar({ className = '' }: HeaderProps) {
  const [open, setOpen] = useState(false)
  return (
    <>
      <NavbarMenu open={open} onChange={setOpen} />
      <div
        className={`fixed z-50 top-0 left-0 flex w-full items-center justify-center md:bg-white md:bg-opacity-60 md:backdrop-blur min-[1722px]:flex-nowrap ${className}`}
      >
        <Section className='flex flex-row w-full items-center py-3 md:py-6 max-w-[1920px]'>
          <a
            href='/'
            className='text-md font-bold leading-[normal] text-transparent hidden lg:block text-nowrap flex-1'
          >
            <span className='bg-clip-text [background-image:linear-gradient(90deg,_#fc2548,_#f11fad)]'>
              THE BRETHREN ASSEMBLY <span className='text-black'>DUBAI</span>
            </span>
          </a>
          <div className='hidden md:flex flex-wrap items-center md:justify-start lg:justify-center gap-x-[16px] text-sm leading-[normal]'>
            <NavbarItem url='/' selected>
              Home
            </NavbarItem>
            <NavbarItem url='/about'>About Us</NavbarItem>
            <NavbarItem url='/gospel'>Gospel</NavbarItem>
            {/* <NavbarItem url='/explore'>Explore</NavbarItem> */}
            <NavbarItem url='/contact'>Contact Us</NavbarItem>
          </div>
        </Section>
      </div>
      <div
        className={`fixed left-0 right-0 top-0 w-screen md:hidden bg-white bg-opacity-80 backdrop-blur z-40 overflow-hidden ${open ? 'h-screen' : 'h-0'} transition-all`}
      >
        <Section className='flex flex-col items-start justify-center gap-y-[24px] pt-[160px]'>
          <NavbarMenuItem url='/' onClick={() => setOpen(false)} index={0}>
            Home
          </NavbarMenuItem>
          <NavbarMenuItem url='/about' onClick={() => setOpen(false)} index={1}>
            About Us
          </NavbarMenuItem>
          <NavbarMenuItem url='/gospel' onClick={() => setOpen(false)} index={2}>
            Gospel
          </NavbarMenuItem>
          {/* <NavbarMenuItem url='/explore' onClick={() => setOpen(false)} index={3}>
            Explore
          </NavbarMenuItem> */}
          <NavbarMenuItem url='/contact' onClick={() => setOpen(false)} index={4}>
            Contact Us
          </NavbarMenuItem>
        </Section>
      </div>
    </>
  )
}
